import LogUtil from '@/core/utils/logUtil';

class AbstractViewFactory {

    protected _viewMap: {[key: string]: any};

    constructor() {
        this._viewMap = {};
    }

    checkViewExists(id: string): boolean {
        if(this._viewMap[id]) {
            return true;
        }

        LogUtil.warn(`View '${id}' not found.`);

        return false;

    }

    getAllViews(): string[] {
        return (this._viewMap) ? Object.keys(this._viewMap) : [];
    }

    getViewDataByID(_id: string): any {
        return {};
    }

    getViewByID(type: string): any {
        if(this._viewMap[type]) {
            return this._viewMap[type];
        }

        LogUtil.warn(`View '${type}' not found.`);

        return null;
    }

    getViewInstanceById(id: string, params: any): any {


        let ViewClass = this.getViewByID(id);

        if(!ViewClass) {
            return;
        }
        return new ViewClass(id, this.getViewDataByID(id), params);
    }

}

export default AbstractViewFactory;
